/* eslint-disable import/no-anonymous-default-export */
export default (receipt = [], action) => {
  switch (action.type) {
    case "GET_ALL_RECEIPT":
      return action.payload;
    default:
      return receipt;
  }
};
